import { render, staticRenderFns } from "./TaoPhong.vue?vue&type=template&id=d93cfea0&"
import script from "./TaoPhong.vue?vue&type=script&lang=js&"
export * from "./TaoPhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports